import { BroadcastMessage } from '@map/core';

export const deleteAllCookiesMessageTag = 'DeleteAllCookiesMessage';
/**
 * Delete all cookies stored in the secure browser
 */
export class DeleteAllCookiesMessage extends BroadcastMessage {
   readonly tag: string = deleteAllCookiesMessageTag;
}
